/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { UpdateCallOrderPayload } from 'api/actions/update-call-order/update-call-order-payload';
import { UpdateCallOrderPathParameters } from 'api/actions/update-call-order/update-call-order-path-parameters';
import { UpdateCallOrderResponse } from 'api/actions/update-call-order/update-call-order-response';

type UpdateCallOrderQueryParameters = Record<string, any>;

/**
 * The path of the UpdateCallOrder action.
 */
export const updateCallOrderActionPath = new SweetPath<keyof UpdateCallOrderPathParameters>('/user/call-order', {
  path: '{param}',
});

/**
 * Creates a contextualized UpdateCallOrder actions.
 */
export default function createUpdateCallOrderAction(axios: AxiosInstance) {
  return function updateCallOrderAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: UpdateCallOrderQueryParameters;
    payload: UpdateCallOrderPayload;
  }) {
    const path = updateCallOrderActionPath.original;

    return axios.put<UpdateCallOrderResponse, UpdateCallOrderResponse, UpdateCallOrderPayload>(path, payload);
  };
}
